import { Box, Button, Typography, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Autocomplete, Tabs, Tab, Checkbox } from "@mui/material"
import { useEffect, useMemo, useState } from "react"
import MonacoEditor from '@monaco-editor/react'
import { GraphQLEditor } from "./graphql-editor";
import { buildSchema } from "graphql";

export const Modal = (props: any) => {

    const defaultTypes = [
        "String",
        "Int",
        "Float",
        "Boolean",
        "DateTime",
        "File",
        "Enum"
    ];
    const [ tabs, setTabs ] = useState(0);

    const [value, setValue] = useState<any>({});

    useEffect(() => {
        setValue({ ...props.selected })
    }, [props.selected])

    const submit = () => {
        props.onSubmit?.(value)
    }

    const schemaString = useMemo(() => {
        let schema = `
        scalar Number
        scalar File
        scalar Int
        scalar Float
        scalar DateTime
        scalar JSON

        type Query {
            empty: String
        }

        type Mutation {
            empty: String
        }
        `;
        props.models.forEach((model) => {
            schema += `type ${model.name} {`
            model.fields?.forEach((field) => {
                schema += `  ${field.key}: ${field.type}`
            })
            schema += '}\n'
        })
        return schema;
    }, [props.models])

    const fieldString = useMemo(() => {
        let string = '';
        value?.fields?.forEach((field) => {
            string += `${field.key}: ${field.type}\n`
        })
        return string;
    }, [value?.fields])

    const addField = () => {
        let fields = (value.fields || []).slice()
        setValue({
            ...value,
            fields: fields?.concat([{}])
        })
    }

    const renderFieldInput = () => {
        if(tabs == 0){

            const updateItem = (ix, item: any, _value: any) => {
                let list = value?.fields?.slice()
                list[ix][item.name] = _value;
                setValue({...value, fields: list})
            }
    
            return (
                <Box>
                    <Box sx={{display: 'flex', gap: '8px'}}>
                        <Box sx={{flex: 1}}>

                        </Box>
                        <Box sx={{flex: 1}}>

                        </Box>
                        <Box>
                            <Typography>Array</Typography>
                        </Box>
                        <Box>
                            <Typography>Required</Typography>

                        </Box>
                    </Box>
                    <Box sx={{display: 'flex', gap: '8px', flexDirection: 'column'}}>
                        {value?.fields?.map((field, ix) => (
                            <Box key={ix} sx={{display: 'flex'}}>
                                <TextField 
                                    value={field.key || ''}
                                    fullWidth 
                                    onChange={(e) => updateItem(ix, {name: 'key'}, e.target.value)}
                                    label="Key"
                                    size="small" />
                                <Autocomplete
                                    value={field.type || ''}
                                    fullWidth
                                    onChange={(e, value) => updateItem(ix, {name: 'type'}, value)}
                                    options={defaultTypes.concat(props.models.map((x) => x.name))} renderInput={(params) => <TextField {...params} size="small" label="Type" />} />
                                <Checkbox 
                                    checked={field.array || false}
                                    onChange={(e) => updateItem(ix, {name: 'array'}, e.target.checked)}
                                    />
                                <Checkbox 
                                    checked={field.required || false}
                                    onChange={(e) => updateItem(ix, {name: 'required'}, e.target.checked)}
                                    />
                            </Box>
                        ))}
                        <Button 
                            onClick={addField}
                            fullWidth>
                                Add
                        </Button>
                    </Box>
                </Box>
            )
        }else{
            return (
                <Box sx={{height: '200px', display: 'flex'}}>
                    <GraphQLEditor  
                        schema={schemaString}
                        initialValue={`type ${value?.name}{
${value?.fields?.map((field) => `  ${field.key}: ${field.type}`).join('\n')}
}`}
                        value={fieldString}/>
                </Box>
            )
        }
    }
    return (
        <Dialog
            fullWidth
            open={props.open}
            onClose={props.onClose}>
            <DialogTitle>{props.selected?.id ? "Update" : "Create"} {props.model.name}</DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', paddingTop: '8px' }}>
                    <TextField 
                        value={value?.name || ''}
                        onChange={(e) => setValue({...value, name: e.target.value})}
                        size="small"    
                        label="Name" />
                    
                    <Typography fontWeight={"bold"}>Fields</Typography>
                    <Tabs value={tabs} onChange={(e, value) => setTabs(value)}>
                        <Tab label="Visual" />
                        <Tab label="Code" />
                    </Tabs>
                    {renderFieldInput()}
                </Box>
            </DialogContent>
            <DialogActions sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: props.selected?.id ? 'space-between' : 'flex-end'
            }}>
                {props.selected?.id ? <Button variant='contained' onClick={props.onDelete} color="error">Delete</Button> : null}
                <Box sx={{ display: 'flex' }}>
                    <Button onClick={props.onClose}>Cancel</Button>
                    <Button onClick={submit} variant="contained">{props.selected?.id ? "Save" : "Create"}</Button>
                </Box>
            </DialogActions>
        </Dialog>
    )
}